import {
    SHOW_PUBLICITY,
    HIDE_PUBLICITY,
} from "./type";


const showPublicity = () => (dispatch) => {
    dispatch({
        type: SHOW_PUBLICITY,
    });
};

const hidePublicity = () => (dispatch) => {
    dispatch({
        type: HIDE_PUBLICITY,
    })
};


export {
    showPublicity,
    hidePublicity,
}
